import { AnyAction } from 'redux';

import { SbPositionT } from '~src/shared/snackbar/SnackbarNotifications';
import { LocalStorageKeys } from '~src/interfaces/localSotrage.types';
import { MediaTypes } from '~src/styles/media-templates';

import * as types from './actionTypes';
import { NotificationI, NotificationSuspensionTypes } from './interfaces';

export const suspendedMessageDisplayed: AnyAction = { type: types.SUSPENDED_MESSAGE_DISPLAYED };

export const showNotification = (notification: NotificationI): AnyAction => ({
  type: types.SHOW_NOTIFICATION,
  payload: notification,
});

export const removeNotification = (id: string): AnyAction => ({
  type: types.REMOVE_NOTIFICATION,
  payload: { id },
});

export const getAppConfig = {
  type: types.GET_APP_CONFIG,
  payload: {
    isNotNewUser: localStorage.getItem(LocalStorageKeys.IsNotNewUser),
    notificationsPosition: localStorage.getItem(LocalStorageKeys.NotificationsPosition) || 'bottom',
  },
};

export const notificationPositionUpdated = (position: SbPositionT): AnyAction => {
  localStorage.setItem(LocalStorageKeys.NotificationsPosition, position);
  return {
    type: types.NOTIFICATIONS_POSITION_UPDATED,
    position,
  };
};

export const setIsNotNewUser = (): AnyAction => {
  localStorage.setItem(LocalStorageKeys.IsNotNewUser, 'true');
  return { type: types.SET_IS_NOT_NEW_USER, payload: { isNotNewUser: true } };
};

export const setMediaSize = (media: MediaTypes): AnyAction => {
  // Also needed in localstorage for the Logger, which has no access to Store
  localStorage.setItem(LocalStorageKeys.MediaQuery, media);
  return { type: types.SET_MEDIA_SIZE, payload: media };
};

export const setNotificationsSuspended = (type: NotificationSuspensionTypes) => ({
  type: types.SET_NOTIFICATIONS_SUSPENDED,
  payload: { type },
});
